import { useState } from 'react'

/** Zeigt das konfigurierte Panel-Logo (Einstellungen → Logo) oder einen Farbverlauf-
 * Platzhalter, falls kein Logo gesetzt ist oder das Bild nicht lädt. `className` steuert
 * Größe/Radius und kommt vom jeweiligen Aufrufer (Sidebar/Topbar/AuthLayout haben
 * unterschiedliche Maße). */
export function BrandMark({ logoUrl, className }: { logoUrl?: string; className?: string }) {
  const [failed, setFailed] = useState(false)

  if (logoUrl && !failed) {
    return <img src={logoUrl} alt="" className={className} style={{ objectFit: 'cover' }} onError={() => setFailed(true)} />
  }
  return <span className={className} />
}
